/**
 * SectionHeading — T22.
 *
 * Renders a small, muted, uppercase section label used for Brief, Output, and History.
 */
import { Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface SectionHeadingProps {
  children: ReactNode;
  mb?: number | string;
}

export function SectionHeading({ children, mb = 8 }: SectionHeadingProps) {
  return (
    <Text component="h2" fz="sm" fw={600} tt="uppercase" c="dimmed" lts="0.05em" m={0} mb={mb}>
      {children}
    </Text>
  );
}
